"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUserDeletionData = exports.asyncJobProgress = exports.deleteUsers = void 0;
/* eslint-disable camelcase */
var deleteUsers = function () { return ({ job_id: 10 }); };
exports.deleteUsers = deleteUsers;
var asyncJobProgress = function () { return ({
    is_finished: true,
    error: '',
    percent_complete: 100,
    result: '',
    total: 20,
    at: 20,
}); };
exports.asyncJobProgress = asyncJobProgress;
var fetchUserDeletionData = function () { return ({
    all_eligible_deletion_users: [
        { id: 1, email: 'john.doe@test.com' },
        { id: 2, email: 'marry.jane@test.com' },
        { id: 3, email: 'sidney.james@test.com' },
        { id: 4, email: 'ricardo.james@test.com' },
        { id: 5, email: 'michael.jordan@test.com' },
        { id: 6, email: 'scotti.pipen@test.com' },
        { id: 7, email: 'roger.federrer@test.com' },
    ],
    all_eligible_unconfirmed_deletion_users: [
        { id: 9, email: 'johnas.doe@test.com' },
        { id: 10, email: 'marryas.jane@test.com' },
        { id: 11, email: 'sidneyas.james@test.com' },
        { id: 12, email: 'ricardoas.james@test.com' },
        { id: 13, email: 'michaelas.jordan@test.com' },
        { id: 14, email: 'scottias.pipen@test.com' },
        { id: 15, email: 'rogeras.federrer@test.com' },
    ],
    seats_remaining_on_license: 4,
    total_users: 20,
    yearly_service: { start: '2020-05-07', end: '2021-05-06' },
}); };
exports.fetchUserDeletionData = fetchUserDeletionData;
